<template>
 <div class="email-list bg-white">
   <div class="container-fluid">
     <sidebar />
      <div v-if="deleteMsg">
          {{statusAlert(true)}}
      </div>
     <div class="col-md-9 col-lg-10 ml-md-auto py-4">
       <div class="header d-flex justify-content-between w-100 align-items-center py-3 mb-3 border-bottom border-dark">
         <h2 class="m-0">メッセージ一覧</h2>
          <b-button class="px-4 py-2" variant="primary" @click="newEmail">新規追加</b-button>
       </div>
       <div v-if="magazine"/>
         <emailList v-if="magazine.data"/>
       </div>
     </div>
   </div>
</template>

<script>
import sidebar from '@/components/_sidebar/sidebar'
import { mapState, mapActions } from 'vuex'
import emailList from './components/emailList'

export default {
  data () {
    return {
    }
  },
  created () {
    this.allMagazine()
    this.$store.commit('setApiStatus', null)
  },
  computed: {
    ...mapState('adminMagazine', ['magazine', 'emailStatus', 'deleteMsg']),
    ...mapState(['apiStatus'])
  },
  methods: {
    ...mapActions('adminMagazine', ['allMagazine']),
    newEmail: function () {
      const list = []
      this.$store.commit('adminMagazine/setMembers', list)
      this.$router.push({ name: 'Create new email' })
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.deleteMsg,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    }
  },
  components: {
    sidebar,
    emailList
  }
}
</script>
